export default {
  // Page title
  'pages.salesOverview.title': 'Sales Overview',
  'pages.salesOverview.subTitle': 'Property and parking sales data statistics and analysis',
  
  // Statistics cards
  'pages.salesOverview.stats.houseCount': 'House Count',
  'pages.salesOverview.stats.parkingCount': 'Parking Count',
  'pages.salesOverview.stats.houseSales': 'House Sales',
  'pages.salesOverview.stats.parkingSales': 'Parking Sales',
  'pages.salesOverview.stats.houseReserve': 'House Reserve',
  'pages.salesOverview.stats.parkingReserve': 'Parking Reserve',
  'pages.salesOverview.stats.totalSales': 'Total Sales',
  'pages.salesOverview.stats.totalReserve': 'Total Reserve',
  
  // Chart titles
  'pages.salesOverview.chart.monthlyTrend': 'Monthly Sales Trend (Last 12 Months)',
  'pages.salesOverview.chart.houseMonthlyTrend': 'House Monthly Sales Trend',
  'pages.salesOverview.chart.parkingMonthlyTrend': 'Parking Monthly Sales Trend',
  'pages.salesOverview.chart.statusDistribution': 'House Status Distribution',
  'pages.salesOverview.chart.parkingStatusDistribution': 'Parking Status Distribution',
  'pages.salesOverview.chart.salesComparison': 'House vs Parking Sales Comparison',
  
  // Chart legends
  'pages.salesOverview.legend.houseSales': 'House Sales',
  'pages.salesOverview.legend.houseReserve': 'House Reserve',
  'pages.salesOverview.legend.parkingSales': 'Parking Sales',
  'pages.salesOverview.legend.parkingReserve': 'Parking Reserve',
  'pages.salesOverview.legend.salesWithCurrency': 'Sales (₱)',
  'pages.salesOverview.legend.reserveWithCurrency': 'Reserve (₱)',
  
  // Tables
  'pages.salesOverview.table.houseStatus': 'House Status Statistics',
  'pages.salesOverview.table.parkingStatus': 'Parking Status Statistics',
  'pages.salesOverview.table.columns.status': 'Status',
  'pages.salesOverview.table.columns.month': 'Month',
  'pages.salesOverview.table.columns.salesWithCurrency': 'Sales (₱)',
  'pages.salesOverview.table.columns.reserveWithCurrency': 'Reserve (₱)',
  'pages.salesOverview.table.columns.trend': 'Trend',
  'pages.salesOverview.table.columns.count': 'Count',
  'pages.salesOverview.table.columns.amount': 'Amount',
  'pages.salesOverview.table.columns.percentage': 'Percentage',
  'pages.salesOverview.table.houseMonthlyData': 'House Monthly Data',
  'pages.salesOverview.table.parkingMonthlyData': 'Parking Monthly Data',
  'pages.salesOverview.label.amount': 'Amount',
  'pages.salesOverview.label.reserve': 'Reserve',
  'pages.salesOverview.status.fallback': 'Status {status}',
  'pages.salesOverview.common.emptyValue': '-',
  
  // Currency symbol
  'pages.salesOverview.currency.symbol': '₱',
  
  // Units
  'pages.salesOverview.unit.count': 'Units',
  'pages.salesOverview.unit.parkingCount': 'Spaces',
  'pages.salesOverview.unit.month': 'Month',
  
  // Loading states
  'pages.salesOverview.loading': 'Loading data...',
  'pages.salesOverview.noData': 'No data available',
  
  // Error messages
  'pages.salesOverview.error.loadData': 'Failed to load data',
  'pages.salesOverview.error.retry': 'Retry',
};
